let current_tab      = 0;
let user_age_index   = -1; // 0: fido no co-signing; 1: fido and show co-signing; 2: pre-paid deals, chatr and no co-signing
let selected_plan    = null;
let submission_id    = null;
let verify_result    = null;
let tab_deciding     = false;
let access_verifying = false;
let submission_saved = false;
let organised_plans  = [];
let existing_user    = false;
let token_type       = false;
let onboarding_info  = [];
let sim_cost         = 0;
let service_fee      = 0;
let shipping_cost    = 0;
let tab_start_index  = 0;      
let onboarding_data_container = {};
const tabMap = {
  0: "general",
  1: "notice",
  2: "user_info",
  3: "summary"
}
const plan_data_mock = [
  {
    plan_id: 0,
    franchise_name: "fido",
    descriptions: {},
    display_price: 234,
    original_price: 234,
    featured: true,
    included_data: 9000,
    bonus_data: 1000,
    plan_type: "byop",
    plan_sku: "sku1",
    soc_codes: "soc1",
    aal_discount: 10,
  },
  {
    plan_id: 1,
    franchise_name: "fido",
    descriptions: {},
    display_price: 234,
    original_price: 234,
    included_data: 1000,
    bonus_data: 1000,
    plan_type: "byop",
    plan_sku: "sku2",
    soc_codes: "soc2",
    aal_discount: 10,
  },
  {
    plan_id: 2,
    franchise_name: "fido",
    descriptions: {},
    display_price: 234,
    original_price: 234,
    included_data: 4000,
    bonus_data: 1000,
    plan_type: "term",
    plan_sku: "sku3",
    soc_codes: "soc3",
    aal_discount: 10,
  },
  {
    plan_id: 3,
    franchise_name: "fido",
    descriptions: {},
    display_price: 234,
    original_price: 234,
    included_data: 6000,
    bonus_data: 1000,
    plan_type: "hup",
    plan_sku: "sku4",
    soc_codes: "soc4",
    aal_discount: 10,
  },
  {
    plan_id: 4,
    franchise_name: "fido",
    descriptions: {},
    display_price: 234,
    original_price: 234,
    included_data: 0,
    bonus_data: 0,
    plan_type: "byop",
    plan_sku: "sku4",
    soc_codes: "soc4",
    aal_discount: 10,
  },
];
const onboarding_data_mock = [
  {
    line_id: 1,
    plan_name: "12.0 55GB",
    sim_pickup_method: "delivery_in_canada",
    activation_type: "HUP",
    aal_plan: null,
    aal_plan_type: null,
    aal_msf: null,
    aal_data: null,
    current_ctn: `(234) - 234 - 2342`,
    hup_msf: 23.50,
    hup_data: 9000,
    finance_device: "iPhone 14",
    finance_downpay: 200.00,
    finance_monthly: 40.00,
    sim_cost: 10,
    sim_shipping_cost: 10,
    port_in_carrier: "Freedom",
    port_in_ctn: "(234) - 234 - 2342",
    port_in_account: "234145134",
    soc_codes: "NEWCOMER -$5X15M OFR10160\nBYOD -$15X12M OFR10113",
    aal_soc_code: "1source ID discount code\n1source ID discount code\n1source ID discount code"
  },
  {
    line_id: 2,
    plan_name: "12.0 55GB",
    sim_pickup_method: "sim_pick_up_via_agency",
    activation_type: "AAL",
    aal_plan: 2,
    aal_plan_type: "term",
    aal_msf: 23.60,
    aal_data: 1000,
    current_ctn: `(234) - 234 - 2342`,
    hup_msf: 23.50,
    hup_data: 9000,
    finance_device: "iPhone 13",
    finance_downpay: 200.00,
    finance_monthly: 40.00,
    sim_cost: 10,
    sim_shipping_cost: 10,
    port_in_carrier: "Freedom",
    port_in_ctn: "(234) - 234 - 2342",
    port_in_account: "234145134",
  },
  {
    line_id: 3,
    plan_name: "12.0 55GB",
    sim_pickup_method: "sim_pick_up_in_store",
    pickup_store_name: "Fido Coquitlam",
    activation_type: "AAL",
    aal_plan: 1,
    aal_plan_type: "byop",
    aal_msf: 23.60,
    aal_data: 1000,
    current_ctn: `(234) - 234 - 2342`,
    hup_msf: 23.50,
    hup_data: 9000,
    sim_cost: 10,
    sim_shipping_cost: 10,
    finance_device: "iPhone 14",
    finance_downpay: 200.00,
    finance_monthly: 40.00,
    port_in_ctn: "(234) - 234 - 2342",
    port_in_account: "234145134"
  },
  {
    line_id: 4,
    plan_name: "12.0 55GB",
    sim_pickup_method: "e_sim",
    activation_type: "AAL",
    aal_plan: 1,
    aal_plan_type: "byop",
    aal_msf: 23.60,
    aal_data: 1000,
    current_ctn: `(234) - 234 - 2342`,
    hup_msf: 23.50,
    hup_data: 9000,
    sim_cost: 20,
    sim_shipping_cost: 10,
    finance_device: "iPhone 14",
    finance_downpay: 200.00,
    finance_monthly: 40.00,
    port_in_ctn: "(234) - 234 - 2342",
    port_in_account: "234145134"
  }
];

function tabDecide(n) {
  const x = document.getElementsByClassName("tab");

  if(current_tab + n < 0 || current_tab + n === x.length) return false;

  if(n > 0) {
    if(tabMap[current_tab] != "general") {
      if(!x[current_tab].querySelector("form").checkValidity()) {
        if(current_tab == 1 || current_tab == 2) x[current_tab].querySelector("form:invalid").reportValidity();
        return false;
      }
    }else {
      const plan_device_form = x[current_tab].querySelector(`#plan_device_form`);

      if(!plan_device_form.checkValidity()) {
        plan_device_form.reportValidity();
        return false;
      }

      if(token_type != "HUP and AAL") {
        const line_sections = x[current_tab].querySelectorAll(".line_section");

        for(let i = 0; line_sections && i < line_sections.length; ++i) {
          if(line_sections[i].style.display != "none") {
            const form = line_sections[i].querySelector("form");

            if(!form.checkValidity()) {
              form.reportValidity();

              return false;
            }
          }
        }
      }
    }
  }

  if(current_tab + n == 3 && !(onboarding_data_container?.payment)) {
    document.getElementById(`payment_button`).click();
    return false;
  }

  x[current_tab].style.display = "none";

  current_tab += n;

  if(current_tab < x.length) {
    tabShow(current_tab);
  }

  if(tabMap[current_tab] === "user_info") {
    // additionalLineSectionHandle();
    userInfoFormUpdate();
  }

  if(tabMap[current_tab] === "summary") {
    totalPriceCal();
  }

  return false;
}

function tabShow(n) {
  // This function will display the specified tab of the form...
  const x               = document.getElementsByClassName("tab");
  const y               = document.getElementsByClassName("step");
  const z               = document.getElementsByClassName("step_name");
  const stepper_circle  = document.getElementsByClassName("stepper_circle");
  const promo_poster    = document.getElementById("promo_poster");
  const campaign_poster = document.getElementById("campaign_poster");
  const left_arrow      = document.getElementById("left_arrow");
  const right_arrow     = document.getElementById("right_arrow");
  const info_process    = document.getElementById("info_process");

  if(n == 0) {
    if(promo_poster) promo_poster.style.display = "block";
    if(campaign_poster) campaign_poster.style.display = "block";
  }else {
    if(promo_poster) promo_poster.style.display = "none";
    if(campaign_poster) campaign_poster.style.display = "none";
  }

  for(let i = 0; i < y.length; ++i) {
    if(i <= n) {
      y[i].classList.add("active");

      i == n ? z[i].style.display = "block" : z[i].style.display = "none";

      if(i < n) {
        stepper_circle[i].textContent = '✔';
        x[i].style.display            = "none";
        stepper_circle[i].addEventListener("click", prevSkip);
      }else {
        stepper_circle[i].textContent = i + 1;
        x[i].style.display            = "block";
        stepper_circle[i].removeEventListener("click", prevSkip);
      }
    }else {
      y[i].classList.remove("active");
      stepper_circle[i].removeEventListener("click", prevSkip);
      z[i].style.display            = "none";
      x[i].style.display            = "none";
      stepper_circle[i].textContent = i + 1;
    }
  }

  if(n === tab_start_index) {
    left_arrow.removeEventListener("click", prevMove);
    left_arrow.classList.add("disable");
  }else {
    left_arrow.addEventListener("click", prevMove);
    left_arrow.classList.remove("disable");
  }

  if(n === (x.length - 1)) {
    right_arrow.removeEventListener("click", nextMove);
    right_arrow.classList.add("disable");
    info_process.style.display = "block";
  }else {
    right_arrow.addEventListener("click", nextMove);
    right_arrow.classList.remove("disable");
    info_process.style.display = "none";
  }

  document.body.scrollTop            = 0;
  document.documentElement.scrollTop = 0;
}

function nextMove(event) {
  if(event) event.preventDefault();
  return tabDecide(1);
}

function prevMove(event) {
  event.preventDefault();
  return tabDecide(-1);
}

function prevSkip(event) {
  const stepper_circle  = document.getElementsByClassName("stepper_circle");

  for(let i = 0; i < stepper_circle.length; ++i) {
    if(stepper_circle[i] === event.target) {
      current_tab = i;
      tabShow(i);
      break;
    }
  }
  
}

function localtionUpdate(e) {
  const minute_of_arrival = document.querySelector(`input[name="minute_of_arrival"]`);
  const hour_of_arrival   = document.querySelector(`input[name="hour_of_arrival"]`);
  const arrival_day       = document.querySelector(`input[name="day_of_arrival"]`);
  const arrival_month     = document.querySelector(`input[name="month_of_arrival"]`);
  const arrival_year      = document.querySelector(`input[name="year_of_arrival"]`);
  const calendar          = document.querySelector(`#arrival_date input[type="date"]`);
  const time_picker       = document.querySelector(`#arrival_time_picker`);
  const n_a_unspecified   = document.querySelector(`input[name="n_a_unspecified"]`);

  e.value = e.checked ? "true" : "";

  if(e.checked) {
    arrival_day.required = arrival_month.required = arrival_year.required = calendar.required = false;
    arrival_day.value    =  arrival_month.value   = arrival_year.value    = "";
    calendar.value       = "";
    calendar.disabled    = true;

    minute_of_arrival.required = hour_of_arrival.required = time_picker.required = false;
    minute_of_arrival.value    = hour_of_arrival.value    = "";
    time_picker.value          = "";
    time_picker.disabled       = true;
    n_a_unspecified.disabled   = true;
    n_a_unspecified.checked    = false;
  }else {
    arrival_day.required = arrival_month.required = arrival_year.required = calendar.required = true;
    calendar.disabled    = false;

    minute_of_arrival.required = hour_of_arrival.required = time_picker.required = true;
    time_picker.disabled       = false;
    n_a_unspecified.disabled   = false;
    n_a_unspecified.checked    = false;
  }
}

function totalPriceCal() {
  const lines                       = onboarding_data_container.multiple_lines;
  const plan_price                  = true ? 
    parseFloat(
      lines.reduce((partial_sum, line) => parseFloat(line.finance_downpay + partial_sum), 0)
    ) : 0;
  const franchise                   = document.querySelector(`#franchise`);
  const summary_table               = document.querySelector(`.summary_table > table > tbody`);
  const item_div                    = document.querySelector(`#item`);
  const price_div                   = document.querySelector(`#price`);
  const total_price_display         = document.getElementById("total_price_display");
  const total_price_display_mobile  = document.getElementById("total_price_display_mobile");
  const payment_method_price        = document.getElementById("payment_method_price");
  const total_price                 = document.getElementById("total_price");
  const finance_device_downpay_text = document.querySelector(`#finance_device_downpay_text`);
  const taxes_included_text         = document.querySelector(`#taxes_included_text`);
  const sim_fee                     = lines ? 
    parseFloat(lines.reduce((partial_sum, line) => partial_sum + line.sim_cost || 0, 0))
    : 
    0;
  const shipping_cost               = lines ? 
    parseFloat(lines.find((line) => line.sim_shipping_cost)?.sim_shipping_cost ?? 0)
    : 
    0;
  const price_float = plan_price ? parseFloat(plan_price) : 0;
  const gst_float   = 0;
  const pst_float   = 0;

  summary_table.innerHTML = `
    <tr>
      <th>${item_div.innerHTML}</th>
      <th>${price_div.innerHTML}</th>
    </tr>
  `;

  lines.forEach(line => {
    summary_table.innerHTML += `
      <tr>
        <td>${line.plan_name}</td>
        <td>$ ${parseFloat(0).toFixed(2)} <span style="color: red">*</span></td>
      </tr>
      <tr>
        <td style="text-transform: capitalize;">${franchise.innerHTML} Multi-SIM Card</td>
        <td>$ ${line.sim_cost?.toFixed(2) ?? "0.00"}</td>
      </tr>
    `;
  });

  lines.forEach((line, line_index) => {
    if(line.finance_downpay) {
      summary_table.innerHTML += `
        <tr style="${line_index ? "" : "border-top:1px solid #ccc;"}">
          <td>${`${finance_device_downpay_text.innerHTML} (${line.finance_device})`}</td>
          <td>${`$ ${parseFloat(line.finance_downpay).toFixed(2)}`}</td>
        </tr>
      `;
    }
  });

  if(shipping_cost) {
    summary_table.innerHTML += ` 
      <tr>
        <td style="text-transform: capitalize;">Shipping Cost</td>
        <td id="sim_td">$ ${shipping_cost.toFixed(2)}</td>
      </tr>
    `;
  }

  const total_price_float = (price_float + sim_fee + shipping_cost).toFixed(2);

  total_price_display.textContent = total_price_display_mobile.textContent = payment_method_price.innerText = `$ ${total_price_float} (${taxes_included_text.innerHTML})`;
  total_price.value               = total_price_float
}

function firstLettercapitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function emailValidate(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function planCompare(a, b) {
  if(a.featured && !b.featured) return -1;
  else if(!a.featured && b.featured) return 1;
  else if(a.calculated_data !== 0 && b.calculated_data === 0) return -1;
  else if(a.calculated_data === 0 && b.calculated_data !== 0) return 1;

  return a.calculated_data - b.calculated_data;
}

function isWechat() {
  const ua = navigator.userAgent.toLowerCase();
  return ua.match(/MicroMessenger/i) == "micromessenger";
}

function portalAccessCodeVerify(data) {
  return new Promise((resolved, reject) => {
    const csrf_token = document.getElementById("csrf_token");
    const http       = new XMLHttpRequest();

    http.open("POST", "/api/verify-access-token", true);

    http.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    http.setRequestHeader("X-CSRF-Token", csrf_token.value);

    http.onreadystatechange = function() {
      if(http.readyState === 4) {
        if(http.status == 200) {
          const response_data    = JSON.parse(http.responseText);
          const token_type_input = document.querySelector(`input[name="token_type"]`);

          token_type_input.value = token_type = response_data.type;

          if(response_data.success) {
            if(response_data.expired) {
              resolved(true);
            }else {
              resolved(false);
            }
          }else {
            reject();
          }
        }else {
          // const token_type_input = document.querySelector(`input[name="token_type"]`);

          // token_type_input.value = token_type = "HUP";
          // resolved();
          reject();
        }
      }
    }

    http.send(JSON.stringify(data));
  });
}

function onboardingInfoRetrieve(data) {
  return new Promise((resolved, reject) => {
    const http = new XMLHttpRequest();

    http.open("POST", `/api/onboarding-token-info`, true);

    http.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    http.onreadystatechange = function() {
      if(http.readyState === 4) {
        if(http.status == 200) {
          // resolved({
          //   payment: 1,
          //   existing_customer: 1,
          //   plan_list: plan_data_mock,
          //   multiple_lines: onboarding_data_mock
          // });
          const response_data = JSON.parse(http.responseText);
          resolved(response_data);
        }else {
          // resolved({
          //   payment: 1,
          //   existing_customer: 1,
          //   plan_list: plan_data_mock,
          //   multiple_lines: onboarding_data_mock
          // });
          reject();
        }
      }
    }

    http.send(JSON.stringify(data));

  });
}

function planCompose(plans = []) {
  const limited_time_offer = document.querySelector("#limited_time_offer");
  const bonus              = document.querySelector("#bonus");
  const no_bonus           = document.querySelector("#no_bonus");
  const per_month          = document.querySelector("#per_month");
  const regular_price      = document.querySelector("#regular_price");
  const no_discount        = document.querySelector("#no_discount");
  const current_language   = document.querySelector("#current_lang");
  const more_plan_detail   = document.querySelector("#more_plan_detail");

  for(let i = 0; i < plans.length; ++i) {
    const plan = plans[i];

    if(plan.included_data === null || plan.included_data === undefined) plan.included_data = 0;
    if(plan.bonus_data === null || plan.bonus_data === undefined) plan.bonus_data = 0;

    plan.calculated_data         = plan.included_data + plan.bonus_data;
    plan.limited_time_offer_text = limited_time_offer.textContent;
    plan.bonus_text              = bonus.textContent;
    plan.no_bonus_text           = no_bonus.textContent;
    plan.per_month_text          = per_month.textContent;
    plan.regular_price_text      = regular_price.textContent;
    plan.no_discount_text        = no_discount.textContent;
    plan.current_language        = current_language.textContent;
    plan.more_plan_detail_text   = more_plan_detail.textContent;
  }

  return plans;
}

function statusTrackingLinkGenerate(token) {
  const status_tracking_url = document.querySelector(`#status_tracking_url > a`);

  if(status_tracking_url) {
    status_tracking_url.href = status_tracking_url.innerHTML = location.protocol + "//" + location.host + location.pathname + `?t=${token}`;
  }
}

function additionalLineSectionHandle() {
  const number_of_lines      = document.querySelector(`input[name="number_of_lines"]`);
  const additional_line_info = document.querySelector(`#additional_line_info`);

  if(number_of_lines && Number(number_of_lines.value) > 1) {
    const plan_line_1         = document.querySelector(`.plan_line`);
    const plan_line_port_1    = document.querySelector(`.plan_line_port`);
    const line                = document.querySelector(`#line`);
    const wireless_plan       = document.querySelector("#wireless_plan");
    const port_in_info        = document.querySelector(`#port_in_info`);
    const section_header_text = document.querySelector(`#additional_line_info_text`);
    const header              = document.createElement("div");
    const hr                  = document.createElement("hr");

    additional_line_info.innerHTML = ``;
    header.innerHTML               = section_header_text.innerHTML;
    header.classList.add("user_form_header");
    additional_line_info.appendChild(hr);
    additional_line_info.appendChild(header);

    for(let i = 1; i < Number(number_of_lines.value); ++i) {
      const plan_line      = plan_line_1.cloneNode(true);
      const plan_line_port = plan_line_port_1.cloneNode(true);

      plan_line.querySelector(`p`).innerHTML = `
        ${line.innerHTML}${i + 1}${wireless_plan.innerHTML} <span style="color: red">*</span>
      `;
      plan_line.querySelector(`select`).setAttribute("name", `plan_name_${i + 1}`);
      plan_line.querySelector(`input`).setAttribute("data-index", i);
      plan_line.querySelector(`input`).setAttribute("name", `port_in_check_${i + 1}`);
      plan_line.querySelector(`input`).setAttribute("autocomplete", `off`);

      plan_line_port.querySelector(`p`).innerHTML = `
        ${line.innerHTML}${i + 1}${port_in_info.innerHTML} <span style="display: none; color: red">*</span>
      `;
      plan_line_port.querySelectorAll(`input`)[0].setAttribute("name", `port_in_phone_number_${i + 1}`);
      plan_line_port.querySelectorAll(`input`)[1].setAttribute("name", `port_in_account_number_${i + 1}`);

      additional_line_info.appendChild(plan_line);
      additional_line_info.appendChild(plan_line_port);
    }

    additional_line_info.style.display = "block";
  }else {
    additional_line_info.innerHTML     = ``;
    additional_line_info.style.display = "none";
  }
}

function agencyInfoRetrieve(token) {
  return new Promise((resolved, reject) => {
    const http = new XMLHttpRequest();

    http.open("GET", `/api/agency-info?token=${token}`, true);

    http.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    http.onreadystatechange = function() {
      if(http.readyState === 4) {
        if(http.status == 200) {
          const response_data = JSON.parse(http.responseText);
          resolved(response_data);
        }else {
          // resolved({
          //   accept_alipay: 0,
          //   accept_squarepay: 1,
          //   accept_wechatpay: 1,
          //   agency_id: 2,
          //   franchise: "fido",
          //   nrc_value: 50
          // });
          reject();
        }
      }
    }

    http.send(null);
  });
}

function agencyInfoUpdate(agency_data = {}) {
  const summary_notation        = document.querySelector(`#summary_notation > div`);
  const summary_notation_mobile = document.querySelector(`#summary_notation_mobile > div`);
  const plan_state              = document.querySelector(`#plan_state`);
  const plan_state1             = document.querySelector(`#plan_state1`);
  const summary_notation_value  = agency_data.nrc_value ? plan_state.innerHTML + " $" + agency_data.nrc_value + plan_state1.innerHTML : plan_state.innerHTML;

  if(summary_notation) {
    summary_notation.innerHTML = `
      <span style="color: red">*</span> ${summary_notation_value}
    `;
  }

  if(summary_notation_mobile) {
    summary_notation_mobile.innerHTML = `
      <span style="color: red">*</span> ${summary_notation_value}
    `;
  }
}

function getToken() {
  const boxes = document.querySelectorAll("#portal_access_code > div:nth-child(2) > input");
  let token = "";

  for(let j = 0; j < boxes.length; ++j) token += boxes[j].value;

  return token;
}

function moreThanDate(date_string, days = 1) {
  const input_data = new Date(date_string);
  const today = new Date();

  today.setHours(0, 0, 0, 0);

  const xDaysFromToday = new Date(today);

  xDaysFromToday.setDate(today.getDate() + days);

  return input_data > xDaysFromToday;
}

function hideIdImageSection() {
  const id_image_section = document.querySelector("#id_image_section");
  const inputs = Array.from(document.querySelectorAll(`#id_image_section input`));

  id_image_section.style.display = "none";

  for (const input of inputs) {
    input.required = false;
  }
}

function planAndAgencyDataPrepare() {
  const data                   = { token: getToken() };
  const agency_id              = document.querySelector(`input[name="agency_id"]`);
  const portal_access_code_div = document.querySelector("#portal_access_code");

  if(agency_id) data.agency_id = agency_id.value;
  
  if(!access_verifying) {
    access_verifying = true;
    statusTrackingLinkGenerate(data.token);     
    portalAccessCodeVerify(data)
      .then((expired_token) => { 
        if(expired_token) {
          window.location.href = window.location.href + `?t=${data.token}`;
          return;
        }

        const delivery_country = document.querySelector("#delivery_country");
        const access_token     = document.querySelector(`input[name="access_token"]`);

        if(access_token) {
          access_token.value = data.token;
        }

        data.access_token = data.token;

        portal_access_code_div.style.display = "none";
        delivery_country.style.display       = "block";
        access_verifying                     = false;
        
        window.deliveryDecide("canada", true);

        agencyInfoRetrieve(data.token).then(function(agency_data) {
          const method_buttons = document.querySelectorAll(`.method_button`);
          const agency_id      = document.querySelector(`input[name="agency_id"]`);

          if(agency_id) {
            agency_id.value = agency_data.agency_id;
          }

          if(method_buttons) {
            if(!agency_data.accept_wechatpay) {
              method_buttons[0].style.display = "none";
            }

            if(!agency_data.accept_alipay) {
              method_buttons[1].style.display = "none";
            }

            if(!agency_data.accept_squarepay) {
              method_buttons[2].style.display = "none";
            }

            if(!agency_data.accept_moneris) {
              method_buttons[3].style.display = "none";
            }
          }
          
          agencyInfoUpdate(agency_data);
        });

        onboardingInfoRetrieve(data).then(function(onboarding_data) {
          const { foreign_country, date_of_arrival } = onboarding_data;

          if (foreign_country == "china") {
            hideIdImageSection();
          }

          if (foreign_country != "domestic" && moreThanDate(date_of_arrival, 3)) {
            Swal.fire({
              title: "",
              text: document.getElementById("three_days_warning_text").textContent,
              icon: "warning",
              confirmButtonText: "OK",
              confirmButtonColor: "#5d6265", 
            });

            const token                  = document.querySelector(`input[name="access_token"]`);
            const boxes                  = document.querySelectorAll("#portal_access_code > div:nth-child(2) > input");
            const portal_access_code_div = document.querySelector("#portal_access_code");
          
            if(token && token.value.length == 8 && boxes) {
              for(let j = 0; j < boxes.length; ++j) {
                boxes[j].disabled = false;
                boxes[j].value    = "";
              }
          
              boxes[token.value.length - 1].disabled = false;
          
            }
              
            portal_access_code_div.style.display = "block";

            const current_url = new URL(window.location.href);

            current_url.search = "";

            window.history.replaceState({}, document.title, current_url);

            return;
          }

          const payment_button = document.querySelector(`#payment_button`);
          const payment        = document.querySelector(`input[name="payment"]`);
          const buttons        = document.querySelectorAll("#above_19 .above_19_button");
          const save_text      = document.querySelector(`#save_text`);
          const plans          = planCompose(onboarding_data.plan_list) || [];

          payment.value             = onboarding_data.payment ? "1" : "0";
          onboarding_data_container = onboarding_data;

          documentType(onboarding_data.foreign_country);

          if(payment.value == "0") {
            payment_button.innerHTML = save_text.innerHTML;
          }

          if(buttons[0]) {
            buttons[0].addEventListener("click", function(event) {
              window.ageAboveClaim(plans, 0);
            });
          }

          if(buttons[1]) {
            buttons[1].addEventListener("click", function(event) {
              window.ageAboveClaim(plans, 1);
            });
          }

          if(buttons[2]) {
            buttons[2].addEventListener("click", function(event) {
              window.ageAboveClaim(plans, 2);
            });
          }

          if(onboarding_data.customer_type == "domestic") {
            current_tab     = 1;
            tab_start_index = 1;
          }

          window.ageAboveClaim(plans, 0);

          if(onboarding_data.existing_customer) {
            const yes_existing_customer = document.querySelector(`#yes_existing_customer`);
            const no_existing_customer  = document.querySelector(`#no_existing_customer`);

            if(yes_existing_customer) {
              yes_existing_customer.checked = true;
            }

            if(no_existing_customer) {
              no_existing_customer.checked = false;
            }
          }

          onboardingInfoDisplay(onboarding_data);

          if(line_add_button) {
            line_add_button.style.display = "none";
          }
        });
      })
      .catch(function(e) {
        access_verifying                     = false;
        portal_access_code_div.style.display = "block";

        Swal.fire({
          title: "",
          text: document.getElementById("portal_access_code_verify_failure").textContent,
          icon: "error",
          confirmButtonText: "OK",
          confirmButtonColor: "#5d6265", 
        });
      });
  }
}

function prefillTokenHandle() {
  const token                  = document.querySelector(`input[name="access_token"]`);
  const boxes                  = document.querySelectorAll("#portal_access_code > div:nth-child(2) > input");
  const portal_access_code_div = document.querySelector("#portal_access_code");

  if(token && token.value.length == 8 && boxes) {
    for(let j = 0; j < boxes.length; ++j) {
      boxes[j].disabled = true;
      boxes[j].value    = token.value[j];
    }

    boxes[token.value.length - 1].disabled = false;

    planAndAgencyDataPrepare();
  }else {
    const logo = document.querySelector("#logo");
    const header_text = document.querySelector("#header_text");
    
    logo.style.display = "none";
    header_text.style.backgroundColor = "#555555";
    portal_access_code_div.style.display = "block";
  }
}

function extractPrice(str) {
  // Regular expression to match the number after "$"
  const regex = /\$(\d+(\.\d+)?)/;

  // Match the regular expression in the string
  const match = str.match(regex);

  // If there's a match, return the number after "$"
  if(match) {
      return parseFloat(match[1]);
  }

  // If no match found, return null or handle the case accordingly
  return "0.00";
}

function extractNumberBeforeGB(str) {
  // Regular expression to match the number before "GB"
  const regex = /(\d+(\.\d+)?)(?=GB)/;

  // Match the regular expression in the string
  const match = str.match(regex);

  // If there's a match, return the number before "GB"
  if(match) {
      return parseFloat(match[1]);
  }

  // If no match found, return null or handle the case accordingly
  return "0.00";
}

function pickupSectionGenerate(sim_pickup_method, pickup_store_name) {
  const delivery_in_canada_text     = document.querySelector(`#delivery_in_canada_text`);
  const sim_pick_up_via_agency_text = document.querySelector(`#sim_pick_up_via_agency_text`);
  const sim_pickup_in_store_text    = document.querySelector(`#sim_pickup_in_store_text`);
  const e_sim_text                  = document.querySelector(`#e_sim_text`);
  const use_current_sim_text        = document.querySelector(`#use_current_sim_text`);
  let res                           = "";

  if(sim_pickup_method == "delivery_in_canada") {
    res = `<div>${delivery_in_canada_text.innerHTML}</div>`;
  }else if(sim_pickup_method == "sim_pick_up_via_agency") {
    res = `<div>${sim_pick_up_via_agency_text.innerHTML}</div>`;
  }else if(sim_pickup_method == "sim_pick_up_in_store") {
    res = `
      <div>${sim_pickup_in_store_text.innerHTML}</div>
      <div style="margin: 0 10px 0 10px;">|</div>
      <div>${pickup_store_name}</div>
    `;
  }else if(sim_pickup_method == "use_current_sim") {
    res = `<div>${use_current_sim_text.innerHTML}</div>`;
  }else{
    res = `<div>${e_sim_text.innerHTML}</div>`;
  }

  return res;
}

function portInSectionGenerate(line) {
  let res = "";
  const port_in_info_text = document.querySelector(`#port_in_info_text`);
  const account_text      = document.querySelector(`#account_text`);
  const port_in_account_number_text = document.querySelector(`#port_in_account_number_text`);
  const port_in_carrier_text = document.querySelector(`#port_in_carrier_text`);

  if(!line.port_in_account && !line.port_in_carrier && !line.port_in_ctn) {
    return res;
  }
  
  res = `
    <div class="content_row">
      <div>${port_in_info_text.innerHTML}</div>
      <div style="text-align: left;" class="highlight_text">
        <div>${line.port_in_ctn ? line.port_in_ctn : "N/A"}</div>
      </div>
    </div>

    <div class="content_row">
      <div>${port_in_carrier_text.innerHTML}</div>
      <div style="text-align: left;" class="highlight_text">
        <div>${line.port_in_carrier ? line.port_in_carrier : "N/A"}</div>
      </div>
    </div>

    <div class="content_row">
      <div>${port_in_account_number_text.innerHTML}</div>
      <div style="text-align: left;" class="highlight_text">
        <div>${line.port_in_account ? line.port_in_account : "N/A"}</div>
      </div>
    </div>
  `;

  return res;
}

function simUploadGenerate(sim_pickup_method, line_id) {
  let res               = "";
  const sim_upload_text = document.querySelector(`#sim_upload_text`);

  res = sim_pickup_method == "sim_pick_up_via_agency" ?
    ` 
      <div class="upload_button">
        ${sim_upload_text.innerHTML} 
      </div>
      <input type="file" name="e_sim_image" data-line-id="${line_id}" required style="display: none;"/>
    ` :
    ""
  
  return res;
}

function financeDevice(line) {
  const finance_device_text = document.querySelector(`#finance_device_text`);
  const own_device_text = document.querySelector(`#customer_own_device_text`);
  const down_payment_text = document.querySelector(`#down_payment_text`);
  const for_24_months_text = document.querySelector(`#for_24_months_text`);
  const taxes_included_text = document.querySelector(`#taxes_included_text`);
  let res = "";

  if (line.finance_device && line.aal_plan_type != "byop") {
    res = `
      <div class="content_row">
        <div>${finance_device_text.innerHTML}</div>
        <div class="highlight_text">${line.finance_device ? line.finance_device : `N/A (${own_device_text.innerHTML})`}</div>
      </div>
      <div class="content_row">
        <div>${finance_detail_text.innerHTML}</div>
        <div style="text-align: left;" class="highlight_text">
          ${
            line.finance_device ? `<p><span class="highlight_text">$${line.finance_downpay.toFixed(2)}</span> ${down_payment_text.innerHTML} + <span class="highlight_text">$${line.finance_monthly.toFixed(2)}</span>${per_month.innerHTML} ${for_24_months_text.innerHTML} ${taxes_included_text.innerHTML}</p>` : `<span class="highlight_text">N/A</span>`
          }
        </div>
      </div>
    `;
  }

  return res;
}

function onboardingInfoDisplay(onboardingInfo) {
  if(onboardingInfo) {
    const plan_section = document.querySelector(`#plan_section`);
    const upgrade_line_text = document.querySelector(`#upgrade_line_text`);
    const add_new_line_text = document.querySelector(`#add_new_line_text`);
    const plan_info_text = document.querySelector(`#plan_info_text`);
    const line_text = document.querySelector(`#line`);
    const sim_card_text = document.querySelector(`#sim_card_text`);
    const upload_sim_image_warning_text = document.querySelector("#upload_sim_image_warning_text");

    if(onboardingInfo.multiple_lines) {
      onboardingInfo.multiple_lines.forEach((line, line_index) => {
        let current      = document.createElement("div");
        let soc_codes    = line.soc_codes ? line.soc_codes : "";
        let aal_soc_code = line.aal_soc_code ? line.aal_soc_code : "";

        if(aal_soc_code) {
          if(soc_codes.length) {
            soc_codes += "\n" + aal_soc_code.split("\n").map(item => item + "(AAL)").join("\n");
          }else {
            soc_codes = aal_soc_code.split("\n").map(item => item + "(AAL)").join("\n");
          }
        }

        current.classList.add("existing_line_section");

        const plan_price = parseFloat(extractPrice(line.plan_name));
        const plan_data  = parseFloat(extractNumberBeforeGB(line.plan_name));

        if(line.activation_type == "HUP") {
          const plan_name = `${plan_data ? `${plan_data}GB` : "Talk & Text"} $${plan_price.toFixed(2)} /mo.`;

          current.innerHTML = `
            <form id="existing_line_${line_index}" class="line_form" enctype="multipart/form-data">
              <div class="head">
                <p>${line_text.innerHTML}  ${line_index + 1} - ${upgrade_line_text.innerHTML} ${line.current_ctn}</p>
              </div>
              <div class="content_row">
                <div>${plan_info_text.innerHTML}</div>
                <div><p><span class="highlight_text">${plan_name}</p></div>
              </div>
              <div class="content_row">
                <div style="align-items: center;">
                  <div>${sim_card_text.innerHTML}</div>
                  <div
                    class="user_form_input_field sim_card highlight_text"
                    style="display: ${line.sim_pickup_method == "sim_pick_up_via_agency" ? "flex" : "none"}; background-color: unset;"
                  >
                    <span class="tooltip_text">${upload_sim_image_warning_text.innerHTML}</span>
                  </div>
                </div>
                <div style="text-align: left;" class="highlight_text">
                  ${pickupSectionGenerate(line.sim_pickup_method, line.pickup_store_name)}
                </div>
              </div>
              ${financeDevice(line)}
              ${portInSectionGenerate(line)}
              ${simUploadGenerate(line.sim_pickup_method, line.line_id)}
              <input type="hidden" name="plan_name" value="${plan_name}">
              <input type="hidden" name="plan_type" value="HUP">
              <input type="hidden" name="plan_data" value="${line.hup_data}">
              <input type="hidden" name="plan_price" value="${line.hup_msf}">
              <input type="hidden" name="finance_device" value="${line.finance_device}">
              <input type="hidden" name="finance_downpay" value="${line.finance_downpay}">
              <input type="hidden" name="finance_monthly" value="${line.finance_monthly}">
              <input type="hidden" name="port_in_ctn" value="${line.port_in_ctn}">
              <input type="hidden" name="port_in_account" value="${line.port_in_account}">
              <input type="hidden" name="port_in_carrier" value="${line.port_in_carrier}">
              <input type="hidden" name="activated_ctn" value="${line.activated_ctn}">
              <input type="hidden" name="current_ctn" value="${line.current_ctn}">
              <input type="hidden" name="soc_codes" value="${soc_codes}">
            </form>
          `;
        }else {
          const plan_name = `${plan_data ? `${plan_data}GB` : "Talk & Text"} $${plan_price.toFixed(2)} /mo.`;

          current.innerHTML = `
            <form id="existing_line_${line_index}" class="line_form" enctype="multipart/form-data">
              <div class="head">
                <p>${line_text.innerHTML}  ${line_index + 1} - ${add_new_line_text.innerHTML}</p>
              </div>
              <div class="content_row">
                <div>${plan_info_text.innerHTML}</div>
                <div><p><span class="highlight_text">${plan_name}</p></div>
              </div>
              <div class="content_row">
                <div style="align-items: center;">
                  <div>${sim_card_text.innerHTML}</div>
                  <div
                    class="user_form_input_field sim_card"
                    style="display: ${line.sim_pickup_method == "sim_pick_up_via_agency" ? "flex" : "none"}; background-color: unset;"
                  >
                    <span class="tooltip_text">${upload_sim_image_warning_text.innerHTML}</span>
                  </div>
                </div>
                <div style="text-align: left;" class="highlight_text">
                  ${pickupSectionGenerate(line.sim_pickup_method, line.pickup_store_name)}
                </div>
              </div>
              ${financeDevice(line)}
              ${portInSectionGenerate(line)}
              ${simUploadGenerate(line.sim_pickup_method, line.line_id)}
              <input type="hidden" name="plan_name" value="${plan_name}">
              <input type="hidden" name="plan_type" value="${line.aal_plan_type}">
              <input type="hidden" name="plan_data" value="${plan_data}">
              <input type="hidden" name="plan_price" value="${plan_price}">
              <input type="hidden" name="finance_device" value="${line.finance_device}">
              <input type="hidden" name="finance_downpay" value="${line.finance_downpay}">
              <input type="hidden" name="finance_monthly" value="${line.finance_monthly}">
              <input type="hidden" name="port_in_ctn" value="${line.port_in_ctn}">
              <input type="hidden" name="port_in_account" value="${line.port_in_account}">
              <input type="hidden" name="port_in_carrier" value="${line.port_in_carrier}">
              <input type="hidden" name="current_ctn" value="${line.port_in_ctn}">
              <input type="hidden" name="activated_ctn" value="${line.activated_ctn}">
              <input type="hidden" name="soc_codes" value="${soc_codes}">
            </form>
          `;
        }

        current.addEventListener("click", event => {
          const target = event.target;

          if (target.classList.contains("upload_button")) {
            const input = current.querySelector(`input[name="e_sim_image"]`);

            input.click();
          }
        });



        const sim_card = current.querySelector(".sim_card");
        const sim_input = current.querySelector(`input[name="e_sim_image"]`);

        if (sim_input) {
          sim_input.addEventListener("change", () => {
            const sim_upload_text = document.querySelector(`#sim_upload_text`);
            const upload_button = current.querySelector(".upload_button");
            const file_to_be_uploaded_text = document.querySelector("#file_to_be_uploaded_text");
            const file_num = sim_input.files.length;

            if (file_num) {
              upload_button.innerText = `${file_num} ${file_to_be_uploaded_text.innerHTML}`;
            } else {
              upload_button.innerText = sim_upload_text.innerHTML;
            }
          });
        }

        sim_card.addEventListener("mouseenter", () => {
          const tooltip = sim_card.querySelector(".tooltip_text");

          tooltipTextShow(tooltip);
        });

        sim_card.addEventListener("mouseleave", () => {
          const tooltip = sim_card.querySelector(".tooltip_text");

          tooltipTextShow(tooltip);
        });

        plan_section.appendChild(current);
      });
    }
  }
}

function newLineBuild() {
  const line_text                = document.querySelector(`#line`);
  const plan_section             = document.querySelector(`#plan_section`);
  const finance_byop_text        = document.querySelector(`#finance_byop_text`);
  const use_my_own_device_text   = document.querySelector(`#use_my_own_device_text`);
  const select_plan_text         = document.querySelector(`#select_plan_text`);
  const port_in_another_num_text = document.querySelector('#port_in_another_num_text');
  const account_number_text      = document.querySelector(`#account_number_text`);
  const port_in_info_text        = document.querySelector(`#port_in_info_text`);
  const finance_device_text      = document.querySelector(`#finance_device_text`);

  if(plan_section) {
    const line_section = [...plan_section.querySelectorAll(`.line_section`)];
    const current      = document.createElement("div");
    let index          = line_section ? 
      line_section.reduce(
        (accumulator, currentValue) => accumulator + (currentValue.style.display === "none" ? 0 : 1),
        0
      ) : 0;

    current.classList.add("line_section");
    current.innerHTML = `
      <form id="new_line_${line_section.length}" class="line_form">
        <div>
          <p>${line_text.innerHTML} ${index + 1}</p>
          <p>X</p>
        </div>
        <div>
          <div>${finance_byop_text.innerHTML} <span style="color: red">*</span></div>
          <div class="user_form_input_field" style="width: 60%">
            <div style="width: 49%; display: flex; margin-right: 2%; align-items: center;">
              <input type="checkbox" id="own_device_${line_section.length}" style="display: initial; margin-left: 0; margin-bottom: 0;">
              <label for="own_device_${line_section.length}">${use_my_own_device_text.innerHTML}</label> 
            </div>
            <input type="text" class="form_input_field" style="width: 49%; box-sizing: border-box;" placeholder="${finance_device_text.innerHTML}" name="finance_device" required>
          </div>
        </div>
        <div>
          <div>${select_plan_text.innerHTML} <span style="color: red">*</span></div>
          <div class="user_form_input_field" style="width: 60%">
            <select name="plan_name" form="new_line_${line_section.length}" style="width: 49%; box-sizing: border-box; margin-right: 2%;" required>
            </select>
            <div style="width: 49%; display: flex; align-items: center;">
              <input type="checkbox" id="port_in_another_number_${line_section.length}" style="display: initial; margin-left: 0; margin-bottom: 0;">
              <label for="port_in_another_number_${line_section.length}">${port_in_another_num_text.innerHTML}</label> 
            </div>
          </div>
        </div>
        <div>
          <div>${port_in_info_text.innerHTML}</div>
          <div class="user_form_input_field" style="width: 60%">
            <input name="port_in_ctn" type="text" onInput="this.value = phoneFormat(this.value)" class="form_input_field" style="width: 49%; box-sizing: border-box; margin-right: 2%;" placeholder="(___)___ - ____" disabled>
            <input name="port_in_account" type="text" class="form_input_field" style="width: 49%; box-sizing: border-box;" placeholder="${account_number_text.innerHTML}" disabled>
          </div>
        </div>
      </form>
    `;
    
    const plan_select     = current.querySelector(`select[name="plan_name"]`);
    const plan_build_func = (type) => {
      if(plan_select && organised_plans) {
        plan_select.innerHTML = "";

        organised_plans
          .filter(item => item.plan_type.toLowerCase() == type)
          .forEach(plan => {
            const option       = document.createElement("option");
            const total_data   = plan.calculated_data >= 1000 ? `${plan.calculated_data / 1000}GB` : `${plan.calculated_data}MB`;
            const aal_discount = plan.aal_discount && (token_type == "AAL Only" || index) ? plan.aal_discount : 0;
            const final_price  = plan.original_price - aal_discount;
            let soc_codes      = plan.soc_codes ? plan.soc_codes : "";
            let aal_soc_code   = plan.aal_soc_code ? plan.aal_soc_code : "";
    
            if(aal_soc_code) {
              if(soc_codes.length) {
                soc_codes += "\n" + aal_soc_code.split("\n").map(item => item + "(AAL)").join("\n");
              }else {
                soc_codes = aal_soc_code.split("\n").map(item => item + "(AAL)").join("\n");
              }
            }
            
            if(plan.calculated_data == 0) {
              option.value = option.innerText = `${firstLettercapitalize(plan.franchise_name)} $${final_price} - Talk & Text`;
            }else {
              option.value = option.innerText = `${firstLettercapitalize(plan.franchise_name)} $${final_price} - ${total_data}`;
            }

            option.setAttribute("data-price", final_price);
            option.setAttribute("data-type", plan.plan_type ? plan.plan_type : "");
            option.setAttribute("data-sku", plan.plan_sku ? plan.plan_sku : "");
            option.setAttribute("data-soc", soc_codes);
  
            plan_select.appendChild(option);
          });
      }
    };

    plan_section.appendChild(current);

    const own_device_checkbox = current.querySelector(`#own_device_${line_section.length}`);
    const port_in_checkbox    = current.querySelector(`#port_in_another_number_${line_section.length}`);
    const finance_device      = current.querySelector(`input[name="finance_device"]`);
    const port_in_number      = current.querySelector(`input[name="port_in_ctn"]`);
    const account_number      = current.querySelector(`input[name="port_in_account"]`);
    const delete_button       = current.querySelector(`div:first-child > p:last-child`);

    if(own_device_checkbox) {
      own_device_checkbox.addEventListener("change", e => { 
        if(e.target.checked) {
          finance_device.required = false;
          finance_device.disabled = true;
          plan_build_func("byop");
        }else {
          finance_device.required = true;
          finance_device.disabled = false;
          plan_build_func("term");
        }
      });
    }

    if(port_in_checkbox) {
      port_in_checkbox.addEventListener("change", e => { 
        if(e.target.checked) {
          port_in_number.disabled = false;
          account_number.disabled = false;
        }else {
          port_in_number.disabled = true;
          account_number.disabled = true;
          port_in_number.value    = "";
          account_number.value    = "";
        }
      });
    }

    if(delete_button) {
      delete_button.addEventListener("click", () => {
        current.style.opacity = "0";
        setTimeout(() =>{
          current.style.display = "none";
          lineReorder();
        }, 200);
      });
    }

    plan_build_func("term");
    lineReorder();
  }
}

function lineReorder() {
  const line_text     = document.querySelector(`#line`);
  const line_sections = [...document.querySelectorAll(".line_section")];
  let count           = 0;

  line_sections.forEach(item => {
    if(item.style.display != "none") {
      item.querySelector("div:first-child > p:first-child").innerText = `${line_text.innerHTML} ${count + 1}`;
      ++count;
    }
  });

  const target = line_sections.find(item => item.style.display !== "none");
  
  target.querySelector(`form > div:first-child > p:nth-child(2)`).style.display = "none";
}

function userInfoFormUpdate() {
  const yes_existing_customer = document.querySelector(`#yes_existing_customer`);
  const new_user_rows         = [...document.querySelectorAll(`.new_user_row`)];
  const existing_user_rows    = [...document.querySelectorAll(`.existing_user_row`)];
  const existing_email        = document.querySelector(`input[name="existing_email"]`);
  const existing_postal_code  = document.querySelector(`input[name="existing_postal_code"]`);
  const bday_selector         = document.querySelector(`#bday_selector`);
  const street                = document.querySelector(`input[name="street_canada"]`);
  const city                  = document.querySelector(`input[name="city_canada"]`);
  const state                 = document.querySelector(`input[name="state_canada"]`);
  const postal_code           = document.querySelector(`input[name="postal_code"]`);
  const email                 = document.querySelector(`input[name="email"]`);
  const address_rows          = Array.from(document.querySelectorAll(`.address_row`));

  if(yes_existing_customer.checked) {
    existing_user_rows.forEach(row => {
      row.style.display = "flex";
    });

    new_user_rows.forEach(row => {
      row.style.display = "none";
    });

    if(existing_user) {
      return;
    }

    const shipping = onboarding_data_container.multiple_lines.find(line => {
      return line.sim_pickup_method == "delivery_in_canada";
    });

    existing_user = true;

    existing_email.required       = true;
    existing_postal_code.required = true;

    existing_email.value       = "";
    existing_postal_code.value = "";

    if(shipping) {
      existing_user_rows[0].style.display = "flex";

      address_rows.forEach(row => {
        row.style.display = "flex";
      });

      street.required      = true;
      city.required        = true;
      state.required       = true;
      postal_code.required = false;
      email.required       = false;
    }else {
      address_rows.forEach(row => {
        row.style.display = "none";
      });

      street.required      = false;
      city.required        = false;
      state.required       = false;
      postal_code.required = false;
      email.required       = false;
    }
  }else {
    existing_user_rows.forEach(row => {
      row.style.display = "none";
    });

    new_user_rows.forEach(row => {
      if(row.getAttribute("id") !== "credit_card1" && row.getAttribute("id") !== "credit_card2") {
        row.style.display = "flex";
      }else {
        row.style.display = "none";
      }
    });

    if(!existing_user) {
      return;
    }

    existing_user = false;

    street.required      = true;
    city.required        = true;
    state.required       = true;
    postal_code.required = true;
    email.required       = true;

    existing_email.required       = false;
    existing_postal_code.required = false;
  }

  // window.under19Detect(bday_selector, `day_of_birth`, `month_of_birth`, `year_of_birth`);
}

function linePlanSelectBuild(plan_select, plan_type) {
  if(plan_select) {
    plan_select.innerHTML = ``;

    organised_plans
      .filter(item => item.plan_type.toLowerCase() == plan_type)
      .forEach(plan => {
        const option     = document.createElement("option");
        const total_data = plan.calculated_data >= 1000 ? `${plan.calculated_data / 1000}GB` : `${plan.calculated_data}MB`;

        option.value = option.innerText = `${firstLettercapitalize(plan.franchise_name)} $${!plan.display_price ? plan.original_price : plan.display_price} - ${total_data}`;
        option.setAttribute("data-price", !plan.display_price ? plan.original_price : plan.display_price);
        option.setAttribute("data-type", plan.plan_type ? plan.plan_type : "");
        option.setAttribute("data-sku", plan.plan_sku ? plan.plan_sku : "");
        option.setAttribute("data-soc", plan.soc_codes ? plan.soc_codes : "");

        plan_select.appendChild(option);
      });
  }
}

function accordinEvent() {
  const acc = document.getElementsByClassName("accordion");

  for (let i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      const panel = document.querySelector(`#panel${i + 1}`);
      
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
        panel.style.border = "unset";
      } else {
        panel.style.borderRight = panel.style.borderBottom = panel.style.borderLeft = "1px solid #e0e0e0";
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  }
}

function yearsGenerate() {
  const min              = new Date().getFullYear();
  const max              = min + 10;
  const primary_select   = document.querySelector("#primary_cc_year_field > select");
  const secondary_select = document.querySelector("#secondary_cc_year_field > select");
  const only_select      = document.querySelector("#only_cc_year_field > select");

  for(let i = min; i <= max; ++i) {
    const option1 = document.createElement("option");
    const option2 = document.createElement("option");
    const option3 = document.createElement("option");

    option1.text  = 
    option1.value = 
    option2.text  = 
    option2.value = 
    option3.text  = 
    option3.value = i;

    primary_select && primary_select.add(option1);
    secondary_select && secondary_select.add(option2);
    only_select && only_select.add(option3);
  }

}

function datePickerReset() {
  const dates = document.querySelectorAll(`input[type="date"]`);

  for(let i = 0; i < dates.length; ++i) dates[i].value = "";
}

function platformDetect() {
  const qr_anchor = document.querySelector("#code_container > a");

  if(isWechat()) {
    document.querySelector(".method_button:last-child").style.display = "none";
    qr_anchor.classList.remove("disable_anchor");
  }else if (window.mobileCheck()) {
    document.querySelector(".method_button:first-child").style.display = "none";
    qr_anchor.classList.remove("disable_anchor");
  }else {
    qr_anchor.classList.add("disable_anchor");
  }
}

function documentType(foreign_country) {
  const panel1 = document.querySelector("#panel1");
  const panel2 = document.querySelector("#panel2");
  let list = [];

  if (foreign_country == "domestic") {
    list = [
      panel1.querySelector(".canadian_passport"),
      panel1.querySelector(".driver_license"),
      panel1.querySelector(".provincial_id"),
      panel2.querySelector(".pr_card"),
      panel2.querySelector(".copr"),
      panel2.querySelector(".credit_card")
    ];
  } else {
    list = [
      panel1.querySelector(".foreign_passport"),
      panel2.querySelector(".work_study_permit")
    ];
  }

  for (const item of list) {
    item.classList.remove("remove_icon");
    item.classList.add("accept_icon");
  }
}

function checkAlliAgree() {
  const notice_form = document.querySelector("#notice_form");
  const foreign_country = document.querySelector(`input[name="foreign_country"]`);

  if (notice_form) {
    notice_form.addEventListener("change", () => {
      const consent = document.querySelector("input#consent");
      const terms = document.querySelector("input#terms_conditions_agree_wrapper");
      const next = document.querySelector('#agree_continue');
      
      if (
        (foreign_country.value == "south_korea" || foreign_country.value == "taiwan") && 
        consent && 
        consent.checked
      ) {
        const i_agree = Array.from(document.querySelectorAll(".i_agree"));

        for (const i of i_agree) {
          i.checked = true;
        }
      }

      if (consent && terms && consent.checked && terms.checked) {
        next.classList.remove('grey_button');
      } else {
        next.classList.add('grey_button');
      }
    });
  }
}

function valueInitialize() {
  const lines = document.querySelector(`input[name="number_of_lines"]`);

  if(lines) lines.defaultValue = 1;
}

function invalidFieldLocate(){
  const delay  = 0;
  const offset = 150;
  const step2  = document.getElementById("user_info_form");
  
  step2.addEventListener("invalid", function (e) {
    // $(e.target).addClass("invalid");
    // $("html, body").animate({ scrollTop: $($(".invalid")[0]).offset().top - offset }, delay);

    e.target.classList.add("invalid");

    const target = document.querySelector(".invalid");

    document.body.scrollTop            = target.offsetTop - offset;
    document.documentElement.scrollTop = target.offsetTop - offset;
  }, true);

  step2.addEventListener("change", function (e) {
    // $(e.target).removeClass("invalid");
    e.target.classList.remove("invalid");
  }, true);

}

function portalAccessDigitHandle() {
  const boxes = document.querySelectorAll("#portal_access_code > div:nth-child(2) > input");
  
  if(boxes) {
    const len = boxes.length;

    for(let i = 0; i < len; ++i) {
      boxes[i].addEventListener("keyup", function(event) {
        const key = event.keyCode || event.charCode;
        
        if(key == 8 || key == 46) {
          if(i > 0) {
            boxes[i].disabled     = true;
            boxes[i].value        = "";
            boxes[i - 1].disabled = false;
            boxes[i - 1].value    = "";
            boxes[i - 1].focus();
          }
        }
      });

      boxes[i].addEventListener("input", function(e) {
        if(e.target.value !== "") {
          if(i < len - 1) {
            boxes[i].disabled     = true;
            boxes[i + 1].disabled = false;
            boxes[i + 1].focus();
          } 
        }
      });

      if(i === len - 1) {
        boxes[i].addEventListener("keypress", function(event) {
          const key = event.keyCode || event.charCode;

          if(key > 47 && key < 58) {
            boxes[i].value = key - 48;
            access_verifying = true;

            const token = getToken();

            portalAccessCodeVerify({ token })
              .then(() => { 
                  window.location.href = window.location.href + `?t=${token}`;
              })
              .catch(function(e) {
                access_verifying = false;
        
                Swal.fire({
                  title: "",
                  text: document.getElementById("portal_access_code_verify_failure").textContent,
                  icon: "error",
                  confirmButtonText: "OK",
                  confirmButtonColor: "#5d6265", 
                });
              });
          }
        });
      }
    }

    boxes[0].disabled = false;
  }

}

function canadaPostConfig() {
  const fields = [   	 
    { element: "street_canada", field: "Line1", mode: pca.fieldMode.DEFAULT },
    { element: "city_canada", field: "City", mode: pca.fieldMode.POPULATE },
    { element: "state_canada", field: "ProvinceName", mode: pca.fieldMode.POPULATE },
    { element: "postal_code", field: "PostalCode", mode: pca.fieldMode.POPULATE  }   
  ]; 
  const options = {   
    key: "UN66-ED71-CE46-RZ76", //API Key
    countries: { codesList: "CAN", fillOthers: false}, //limit the auto-complete to Canada-only addresses
  };
  const control = new pca.Address(fields, options);
}

function invokeIdInput() {
  const id_image = document.querySelector(`input[name="id_image"]`);
  const id_image_2 = document.querySelector(`input[name="id_image_2"]`);
  const id_upload_button_1 = document.querySelector("#id_upload_button_1");
  const id_upload_button_2 = document.querySelector("#id_upload_button_2");
  const file_to_be_uploaded_text = document.querySelector("#file_to_be_uploaded_text");
  
  id_upload_button_1.addEventListener("click", () => {
    id_image.click();
  });

  id_upload_button_2.addEventListener("click", () => {
    id_image_2.click();
  });

  id_image.addEventListener("change", () => {
    const file_qty = id_image.files.length;

    if (file_qty) {
      id_upload_button_1.innerHTML = file_qty + " " + file_to_be_uploaded_text.innerHTML;
    }
  });

  id_image_2.addEventListener("change", () => {
    const file_qty = id_image_2.files.length;

    if (file_qty) {
      id_upload_button_2.innerHTML = file_qty + " " + file_to_be_uploaded_text.innerHTML;
    }
  });
}

window.addEventListener("load", function() {
  window.phoneFormat = function(input) {
    input = input.replace(/\D/g,'');
    
    const size = input.length;

    if(size > 0) {
      input = "(" + input;
    }

    if(size > 3) {
      input = input.slice(0, 4) + ") " + input.slice(4, 11);
    }

    if(size > 6) {
      input = input.slice(0, 9) + " - " + input.slice(9);
    }

    return input;
  };

  window.mobileCheck = function() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };
  
  window.tooltipTextShow = function(e) {
    e.style.visibility === "visible" ? e.style.visibility = "hidden" : e.style.visibility = "visible";
  };
  
  window.checkboxUpdate = function(e) {
    e.value = e.checked ? "true" : "";
  };
  
  window.dateUpdate = function(e, day_name, month_name, year_name) {
    const og_date  = new Date(e.value);
    const date     = new Date(og_date.getTime() + og_date.getTimezoneOffset() * 60000)
    
    if(date && !isNaN(date.getDate()) && !isNaN(date.getMonth()) && !isNaN(date.getFullYear())) {
      document.querySelector(`input[name="${day_name}"]`).value   = date.getDate();
      document.querySelector(`input[name="${month_name}"]`).value = date.getMonth() + 1;
      document.querySelector(`input[name="${year_name}"]`).value  = date.getFullYear();
    }
  };
  
  window.under19Detect = function(e, day_name, month_name, year_name) {
    const date       = new Date(e.value);
    const age_dif_ms = Date.now() - date.getTime();
    const age_date   = new Date(age_dif_ms);
    const age        = Math.abs(age_date.getUTCFullYear() - 1970);
    const warning    = document.getElementById("under_19_warning");
  
    dateUpdate(e, day_name, month_name, year_name);
    
    if(!isNaN(age) && age <= 18) {
      warning.style.display  = "flex";
    }
  };
  
  window.ageAboveClaim = function(plans, age_index) {
    const above_19        = document.getElementById("above_19");
    const stepper_header  = document.getElementById("stepper_header");
    const submission_form = document.getElementById("submission_form");
    const promo_poster    = document.getElementById("promo_poster");
    const bday_selector   = document.getElementById("bday_selector");
    let final_plans       = null;
  
    if(stepper_header) stepper_header.style.display = "block";
    if(submission_form) submission_form.style.display = "block";
    if(above_19) above_19.style.display = "none";
    if(promo_poster) promo_poster.style.display = "block";
  
    final_plans = plans;
  
    if(age_index > 0) {
      if(age_index === 2) {
        const id_verification            = document.getElementById("id_verification");
        const hr                         = document.querySelector("#user_info_form > hr");
        const preferred_last_four_digits = document.getElementById("preferred_last_four_digits");
        const nrc_notation               = document.querySelector("#summary_notation > div:first-child");
        const nrc_notation_mobile        = document.querySelector("#summary_notation_mobile > div:first-child");
  
        final_plans            = plans.filter(plan => plan.franchise_name && plan.franchise_name.toLowerCase() === "chatr");
        nrc_notation.innerText = nrc_notation_mobile.innerText = "";
  
        id_verification.remove();
        preferred_last_four_digits.remove();
        hr.remove();
      }
  
      bday_selector.onchange = function() { 
        dateUpdate(this, `day_of_birth`, `month_of_birth`, `year_of_birth`);
      };
    }
  
    user_age_index = age_index;
    final_plans.sort(planCompare);
    organised_plans = final_plans;

    tabShow(current_tab);
  };
  
  window.emailValidityCheck = function(e, invalid_msg) {
    const validity = emailValidate(e.value);
  
    if(validity === false) {
      e.setCustomValidity(invalid_msg);
    }else e.setCustomValidity("");
  };

  document.querySelector("#user_info_form .prev_btn").addEventListener("click", prevMove);

  document.querySelector("#user_info_form .next_btn").addEventListener("click", nextMove);

  document.querySelector("#notice_form .next_btn").addEventListener("click", nextMove);

  document.querySelector(".general_info_buttons .next_btn").addEventListener("click", nextMove);

  document.querySelector(`input[name="in_canada"]`) && document.querySelector(`input[name="in_canada"]`).addEventListener("change", function(event) {
    localtionUpdate(event.target);
  });

  document.querySelector(`input[name="n_a_unspecified"]`) && document.querySelector(`input[name="n_a_unspecified"]`).addEventListener("change", function(event) {
    const minute_of_arrival = document.querySelector(`input[name="minute_of_arrival"]`);
    const hour_of_arrival   = document.querySelector(`input[name="hour_of_arrival"]`);
    const time_picker       = document.querySelector(`#arrival_time_picker`);

    if(event.target.checked) {
      if(minute_of_arrival) {
        minute_of_arrival.value    = "";
        minute_of_arrival.required = false;
        minute_of_arrival.disabled = true;
      }

      if(hour_of_arrival) {
        hour_of_arrival.value      = "";
        hour_of_arrival.required   = false;
        hour_of_arrival.disabled   = true;
      }

      if(time_picker) {
        time_picker.disabled = true;
        time_picker.value    = "";
      }
    }else {
      if(minute_of_arrival) {
        minute_of_arrival.value    = "";
        minute_of_arrival.required = true;
        minute_of_arrival.disabled = false;
      }
      
      if(hour_of_arrival) {
        hour_of_arrival.value      = "";
        hour_of_arrival.required   = true;
        hour_of_arrival.disabled   = false;
      }

      if(time_picker) {
        time_picker.disabled = false;
        time_picker.value    = "";
      }
    }
  });

  document.querySelector(`input[name="number_of_lines"]`) && document.querySelector(`input[name="number_of_lines"]`).addEventListener("change", function(event) {
    if(event.target.value == "") event.target.value = 1;
    else if(parseFloat(event.target.value) > 7) event.target.value = 7;

    totalPriceCal();
  });

  document.querySelector("#primary_cc_month_field > select") && document.querySelector("#primary_cc_month_field > select").addEventListener("change", function(event) {
    document.querySelector(`input[name="primary_id_expiry_month"]`).value = event.target.value;
    document.querySelector(`input[name="primary_id_expiry_day"]`).value   = "1";
  });

  document.querySelector("#secondary_cc_month_field > select") && document.querySelector("#secondary_cc_month_field > select").addEventListener("change", function(event) {
    document.querySelector(`input[name="secondary_id_expiry_month"]`).value = event.target.value;
    document.querySelector(`input[name="secondary_id_expiry_day"]`).value   = "1";
  });

  document.querySelector("#only_cc_month_field > select") && document.querySelector("#only_cc_month_field > select").addEventListener("change", function(event) {
    document.querySelector(`input[name="only_id_expiry_month"]`).value = event.target.value;
    document.querySelector(`input[name="only_id_expiry_day"]`).value   = "1";
  });

  document.querySelector("#primary_cc_year_field > select") && document.querySelector("#primary_cc_year_field > select").addEventListener("change", function(event) {
    document.querySelector(`input[name="primary_id_expiry_year"]`).value = event.target.value;
  });

  document.querySelector("#secondary_cc_year_field > select") && document.querySelector("#secondary_cc_year_field > select").addEventListener("change", function(event) {
    document.querySelector(`input[name="secondary_id_expiry_year"]`).value = event.target.value;
  });

  document.querySelector("#only_cc_year_field > select") && document.querySelector("#only_cc_year_field > select").addEventListener("change", function(event) {
    document.querySelector(`input[name="only_id_expiry_year"]`).value = event.target.value;
  });

  document.querySelector("#line_add_button p").addEventListener("click", function(event) {
    const line_sections        = [...document.querySelectorAll(`.line_section`)].filter(item => item.style.display != "none");

    if(line_sections.length >= 7) {
      return;
    }

    newLineBuild();
  });

  yearsGenerate();
  datePickerReset();
  platformDetect();
  valueInitialize();
  invalidFieldLocate();
  portalAccessDigitHandle();
  canadaPostConfig();
  checkAlliAgree();
  accordinEvent();
  prefillTokenHandle();
  invokeIdInput();
});

$(document).ready(function() {
  if($("#bday_selector")[0] && $("#bday_selector")[0].type != "date" ) $("#bday_selector").datepicker();
  if($("#arrival_date_picker")[0] && $("#arrival_date_picker")[0].type != "date" ) $("#arrival_date_picker").datepicker();
  if($("#guardian_ip_date_picker")[0] && $("#guardian_ip_date_picker")[0].type != "date" ) $("#guardian_ip_date_picker").datepicker();
  if($("#primary_id_date")[0] && $("#primary_id_date")[0].type != "date" ) $("#primary_id_date").datepicker();
  if($("#secondary_id_date")[0] && $("#secondary_id_date")[0].type != "date" ) $("#secondary_id_date").datepicker();

  $("#arrival_time_picker") && $("#arrival_time_picker").timepicker({
    timeFormat: "HH:mm",
    interval: 1,
    dynamic: false,
    dropdown: true,
    scrollbar: true,
    change: function(time) {
      const minute_of_arrival = document.querySelector(`input[name="minute_of_arrival"]`);
      const hour_of_arrival   = document.querySelector(`input[name="hour_of_arrival"]`);

      if(minute_of_arrival) minute_of_arrival.value = time.getMinutes();
      if(hour_of_arrival) hour_of_arrival.value = time.getHours();
    }
  });

  $.getJSON('https://json.geoiplookup.io/?callback=?', function (data) {
    document.getElementById("current_city").value    = data.city;
    document.getElementById("current_state").value   = data.region;
    document.getElementById("current_country").value = data.country_name;  
  });
});